// extracted by mini-css-extract-plugin
export default {"input_box":"styles_input_box__zSw1J"};